// extracted by mini-css-extract-plugin
export default {"AdminOptions":"AdminOptions_AdminOptions__481T-"};